import React, { FC, memo } from 'react'

import { StorageIds } from '@sportworld/js-sdk/src/constants/storage'

import { updateUcStatus } from '@/actions'
import { Button } from '@/components/Button/Button'
import { SettingsHeader } from '@/components/SettingsHeader'
import { focusIds } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { consentLayoutData } from '@/constants/settings'
import {
  ButtonWrapper,
  CardEl,
  HeaderElement,
  Title,
} from '@/containers/Region/styles'
import { ContentContainer, Description } from '@/containers/Usercentrics/styles'
import { showUCBanner } from '@/containers/Usercentrics/usercentricsUtils'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useStore from '@/store/useStore'

import { SettingsContainer } from '../styles'

const focusId = `${focusIds.USERCENTRICS}${focusIds.CONTAINER_MOD}`

const ConsentRaw: FC = () => {
  const { t } = useCommonTranslation()
  const appConfig = useStore((state) => state.common.appConfig)
  const setUsercentricsPopup = useStore(
    (state) => state.common.setUsercentricsPopup,
  )
  const useCustomUCPopup = false
  const buttonHandler = () => {
    if (useCustomUCPopup) {
      const ucUserInteraction = localStorage.getItem(
        StorageIds.ucUserInteraction,
      )
      if (ucUserInteraction) {
        setUsercentricsPopup(true)
      } else {
        appConfig?.region?.userCentricsId &&
          updateUcStatus(appConfig?.region?.userCentricsId)
      }
    } else {
      showUCBanner()
    }
  }

  return (
    <SettingsContainer focusId={focusId} elementType="div">
      <SettingsHeader title={t(consentLayoutData.title)} />
      <ContentContainer>
        <CardEl>
          <HeaderElement>
            <Title>{t(consentLayoutData.subtitle)}</Title>
            <Description>{t(consentLayoutData.description)}</Description>
          </HeaderElement>
          <ButtonWrapper>
            <Button
              iconSrc={icons.navigation.arrowRight}
              text={t('change')}
              onClick={buttonHandler}
            />
          </ButtonWrapper>
        </CardEl>
      </ContentContainer>
    </SettingsContainer>
  )
}

export const Consent = memo(ConsentRaw)
